import React, { FC, PropsWithChildren, ReactNode } from 'react';

import MuiIcon from '../../../../MUI/MuiIcon';

import * as Styled from './styled';

export type Props = PropsWithChildren<{
  heading: ReactNode;
  isDisabled?: boolean;
  shouldShowError: boolean;
  topicTitle?: string;
}>;

/**
 * Wraps a section for the message compose
 * (assignees, checklist, dateDue, label)
 *
 * @param props                 Props passed to the component
 * @param props.children        Section contents
 * @param props.heading         What to render as the section heading (usually just a heading string)
 * @param props.isDisabled      Should the chevron be shown (don't show for inline sections)
 * @param props.shouldShowError Whether to show the error state
 * @param props.topicTitle      The title of the topic
 * @returns                     The component itself
 */
const ComposeMetaTopicTrigger: FC<Props> = ({
  children,
  heading,
  isDisabled = false,
  shouldShowError,
  topicTitle,
}) => {
  return (
    <Styled.Wrapper>
      {heading}
      <Styled.TopicName data-is-missing={shouldShowError}>
        {children}
      </Styled.TopicName>
      {isDisabled === false && (
        <MuiIcon
          color={shouldShowError ? 'error' : 'primary'}
          icon="arrowDropDown"
        />
      )}
      <input
        hidden={true}
        readOnly={true}
        required={true}
        type="text"
        value={topicTitle ?? ''}
      />
    </Styled.Wrapper>
  );
};

export default ComposeMetaTopicTrigger;
